/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsDeploymentCloudProvider } from './vcdsDeploymentCloudProvider';
import { VcdsDeploymentNetwork } from './vcdsDeploymentNetwork';


export interface TenantVcdsDeploymentAttributes { 
    cloud_provider?: VcdsDeploymentCloudProvider;
    network?: VcdsDeploymentNetwork;
}

